module.exports = __webpack_public_path__ + "img/orange_share.22dcddf2.svg";